import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { Formik } from "formik";
import axios from "axios";
import swal from "sweetalert";

import LoginBanner from "../images/loginbg.png";
import Row from "react-bootstrap/Row";
import LangSwitcher from './common/LanguageSwitcher';

export default function ChangePassword() {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [passwordType, setPasswordType] = useState("password");
  const [passwordType2, setPasswordType2] = useState("password");
  const [conPasswordType, setConPasswordType] = useState("password");

  const token = localStorage.getItem("token");

  const validationSchema = Yup.object().shape({
    oldpassword: Yup.string().required(t('validation_empty_error'))
    .min(6, t('validation_pass_min'))
    .max(40, t('validation_pass_max')),
    newpassword: Yup.string().required(t('validation_empty_error'))
    .min(6, t('validation_pass_min'))
    .max(40, t('validation_pass_max')),
    confirmpassword: Yup.string().required(t('validation_empty_error')).when("newpassword", {
      is: val => (val && val.length > 0 ? true : false),
      then: Yup.string().oneOf(
        [Yup.ref("newpassword")],
        t('validation_pass_match')
      )
    })
  });

  const backAction = () => {
    navigate("/features");
  }
  const handleShowPassword = () => {
    if (passwordType === "password") 
      setPasswordType("text");
    else 
      setPasswordType("password");
  };
  const handleConShowPassword = () => {
    if (conPasswordType === "password") 
      setConPasswordType("text");
    else 
      setConPasswordType("password");
  };
  

  const handleShowPassword2 = () => {
    if (passwordType2 === "password") 
      setPasswordType2("text");
    else 
      setPasswordType2("password");
  };
  /* 
  const errors =  useState([]);
  const [fieldTouched, setFieldTouched] = useState([]);
  i18n.on('languageChanged', () => {
    console.log('AAAAAAAAAAAAAA');
      Object.keys(errors).forEach(fieldName => {
          setFieldTouched(fieldName)
      })
  })
*/

  return (
    <>
    

      <div className="change-password">
        <div className="login">
        <div className="d-flex flex-column-reverse flex-md-row">
            <div className="w-100 w-md-40">
            <div className="login-form-container">
              
              <div className="contact01 main-left-form">
                <div className="login-form-head mb-4">
                  <div className="form-heading">
                    <h3>{t('update_pass_heading1')}</h3>
                  </div>
                </div>
                <div className="login-form m-0">
                  <div className="main-form">
<Formik
      initialValues={{
        oldpassword: "",
        newpassword: "",
        confirmpassword: ""
      }}
      validationSchema={validationSchema}
      onSubmit = {async (data) => {        
        await axios       
          .post(process.env.REACT_APP_API_KEY+"api/change-password", data,
          {headers: {
            "Content-type": "Application/json",
            "Accept": "Application/json",
            "Authorization": `Bearer `+token,
            "sellang": localStorage.getItem("selectLang")
            }   
          })
          .then((res) => {
            if (res.data.status === true) {
                swal({
                  title: "Wow!",
                  text: res.data.message,
                  icon: "success",
                  button: "Okay",
                }).then(function () {
                navigate("/features");
              });
              
            } else {
              swal("Oops", res.data.message, "error");
            }
            console.log(res.data.message);
          }).catch(error => {

            if(error.response.status == 401 && error.response.data.message == 'Unauthenticated.') {
               localStorage.removeItem("token")
               localStorage.removeItem("userData")
               localStorage.removeItem("fname")
               localStorage.removeItem("lname")
               localStorage.removeItem("nameImage")
               localStorage.removeItem("otpCounter")
               localStorage.removeItem("USERLOGIN")
               navigate("/");
           } else {
             swal("Oops", "Something went wrong.", "error");
           }

            //swal("Oops", "Unauthorized User", "error");
            //console.log('aya',error.response);
        });


      }}
    >
      {({ values, errors, handleSubmit, handleChange, handleBlur }) => {
        return (
                    <div>
                      <form onSubmit={handleSubmit}>
                      <div className="icon-input mb-4">
                          <label>{t('update_pass_old')}<span className="text-danger">*</span>
                          </label>
                          <div className="position-relative">
                          <input type={passwordType2} id="oldpassword" name="oldpassword" className="form-control" onBlur={handleBlur} onChange={handleChange} value={values.changepassword}/>
                          <span style={{ cursor: "pointer" }} className="field_icon toggle-password" onClick={handleShowPassword2} >
                            <i className={ passwordType2==='password'? `fa fa-eye`: `fa fa-eye-slash`}  aria-hidden="true" />
                          </span>
                          </div>
                          <div className="text-danger">
                            {errors.oldpassword ? errors.oldpassword : null}
                          </div>
                        </div>
                        <div className="icon-input mb-4">
                          <label>
                          {t('update_pass_new')}<span className="text-danger">*</span>
                          </label>
                          <div className="position-relative">
                          <input type={passwordType} id="newpassword" name ="newpassword" className="form-control" onBlur={handleBlur} onChange={handleChange} value={values.changepassword}/>
                          <span style={{ cursor: "pointer" }} className="field_icon toggle-password" onClick={handleShowPassword} >
                            <i className={ passwordType==='password'? `fa fa-eye`: `fa fa-eye-slash`}  aria-hidden="true" />
                          </span>
                          </div>
                        <div className="text-danger">
                          {errors.newpassword ? errors.newpassword : null}
                        </div>
                        </div>
                        <div className="icon-input">
                          <label>
                          {t('update_pass_confirm')}
                            <span className="text-danger">*</span>
                          </label>
                          <div className="position-relative">
                          <input type={conPasswordType} id="confirmpassword" name="confirmpassword" className="form-control" onBlur={handleBlur} onChange={handleChange} value={values.changepassword}/>
                          <span style={{ cursor: "pointer" }} className="field_icon toggle-password" onClick={handleConShowPassword} >
                            <i className={ conPasswordType==='password'? `fa fa-eye`: `fa fa-eye-slash`}  aria-hidden="true" />
                          </span>
                          </div>
                        <div className="text-danger">
                          {errors.confirmpassword ? errors.confirmpassword : null}
                        </div>
                        </div>
                        
                        <div className="login-btn-box d-flex">
                        <button type="button" onClick={backAction} className="btn btn-red-bg btn-md nav-btn fill back-btn">{t('reset_button_back')}</button>
                          <button type="submit" className="btn btn-red-bg btn-md nav-btn02 fill02">{t('update_pass_heading1')}</button>
                        </div>
                      </form>
                    </div>
);
}}
</Formik>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-100 w-md-60">
            <div className="right-box">
              <img src={LoginBanner} alt="" className="img-fluid login-bg" />
              <div className="banner-text px-4">
                <div>
                  <p id="welcome">{t('forgot_welcome')}</p>
                  <p>{t('forgot_msg')}</p>
                  <div id="line"></div>
                  <span>{t('forgot_line_msg')}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </>
  )
}